import { Classes } from '@blueprintjs/core';
import { useTranslation } from '@web_opxp/features';

interface IProductLabelProps {
  productId: number;
  family: boolean;
}

export default function ProductLabel({ productId, family }: Readonly<IProductLabelProps>) {
  const { t } = useTranslation();
  const productTitle = t([
    `common.products:Current.${productId}`,
    `common.products:Legacy.${productId}`,
    'common.products:Legacy.unknown',
  ]);
  const familyBadge = family ? (
    <small className={`${Classes.TAG} ${Classes.INTENT_SUCCESS} ${Classes.MINIMAL}`}>
      {t('manage:Manage.Subscription.FamilyPackage')}
    </small>
  ) : null;
  return (
    <div className="row">
      <div className="col-3 col-m-2">
        <p className="label">{t('manage:Manage.Subscription.Title')}</p>
      </div>
      <div className="col-9 col-m-2">
        <p>
          {productTitle} {familyBadge}
        </p>
      </div>
    </div>
  );
}
